<template>
  <div>
    <BreadCrumb class="bread" :breads="['商品管理','分组识别率']"></BreadCrumb>
    <div class="wrap">
      <div class="header">
        <span class="nameFt">分组识别率</span>
      </div>
    </div>
    <div class="submit-form">
      <el-form :model="search" :inline="true" size="small" label-width="80px">
        <div class="submit-form__search">
          <el-form-item label="分组名称">
            <el-input v-model="search.name" suffix-icon="el-icon-search" @focus="setDialogSearchItem('group_name')"
              readonly></el-input>
          </el-form-item>
          <el-form-item label="统计方式">
            <el-select v-model="search.time_type">
              <el-option value="30_DAYS" label="按日统计"></el-option>
              <el-option value="ONE_YEAR" label="按月统计"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="submit-form__operate">
          <el-form-item>
            <el-button class="queryBtn" size="small" type="primary" @click="searchForm">查询</el-button>
            <el-button class="queryBtn" size="small" type="primary" @click="reset">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="table-con">
      <el-table :data="tableList" stripe v-loading="loading">
        <el-table-column type="index" label="序号" align="center" :index="indexMethod"></el-table-column>
        <el-table-column label="时间" align="center" prop="date"></el-table-column>
        <el-table-column label="分组名称" align="center" prop="goodsgroup"></el-table-column>
        <el-table-column label="订单数量" align="center" prop="order_amount"></el-table-column>
        <el-table-column label="准确率" align="center" prop="accuracy"></el-table-column>
        <el-table-column label="错误订单" align="center" prop="error_order"></el-table-column>
        <el-table-column label="低信订单" align="center" prop="low_order"></el-table-column>
      </el-table>
    </div>
    <div class="paginationWrap">
      <el-pagination @current-change="handleCurrentChange" :page-size="pageSize" :current-page="pageNum"
        :layout="pageLayout" :total="total">
      </el-pagination>
    </div>
    <simple-find-dialog :show="dialogVisible" @close="closeSimpleDialog" :dialogData="dialogData" :width="'500px'">
    </simple-find-dialog>
  </div>
</template>

<script>
  import SimpleFindDialog from "@/components/SimpleFindDialog";
  import BreadCrumb from "@/components/BreadCrumb";
  import listMixin from "@/mixins/list";
  import apis from "@/config/apis";
  import alert from "@/plugins/alert";
  export default {
    components: {
      BreadCrumb,
      SimpleFindDialog
    },
    mixins: [listMixin],
    data() {
      return {
        search: {
          time_type: '30_DAYS'
        },
        dialogVisible: false,
        dialogData: {},
        dialogName: ''
      }
    },
    created() {
      this.search = Object.assign(this.search, this.$route.query);
      this.getData();
    },
    methods: {
      getData() {
        if (this.search.name && this.search.time_type) {
          this.getTableData(apis.goods_rate, 'get', this.search);
        }
      },
      searchForm() {
        this.search.page_index = 1;
        this.getData();
      },
      reset() {
        this.search = {
          time_type: '30_DAYS'
        };
        this.tableList = [];
        this.total = 0;
        this.searchForm();
      },
      setDialogSearchItem(name) {
        this.dialogName = name;
        switch (name) {
          case 'group_name':
            this.dialogData = {
              searchItems: [{
                key: "name",
                label: "分组名称"
              }],
              searchTableItem: [{
                key: "name",
                name: "分组名称"
              }],
              proxyLink: "goods_group",
              proxyType: "get"
            };
            break;
        }
        this.dialogVisible = true;
      },
      closeSimpleDialog(data) {
        this.dialogVisible = false;
        if (data) {
          switch (this.dialogName) {
            case 'group_name':
              this.search.name = data.name;
              break;
          }
        }
      }
    }
  }
</script>

<style>

</style>